<template>
  <div class="container-fluid">
    <div>
      <div class="card">
        <div class="card-header">
          <div class="row">
            <div class="col col-xs-2">
              <h4 class="panel-title">
                <span class="title">Gerenciamento das Categorias de Tarifa.</span>
                <br />
                <span class="navigation">Cadastros > Categorias Tarifa</span>
              </h4>
            </div>
          </div>
        </div>
        <div class="card-body">
          <form name="form" @submit.prevent="onSubmit">
            <div class="row">
              <div class="col-md-6 mb-2">
                <label for="nome">Nome:</label>
                <span class="p-fluid">
                  <InputText type="text" id="nome" maxlength="500" v-model="CategoriaTarifa.nome" />
                </span>
                <small v-show="validationErrors.nome" class="p-error">Nome é Obrigatório.</small>
              </div>
            </div>
            <hr />
            <template>
              <Button label="Gravar" title="Gravar" type="submit" class="p-button-primary mr-2 p-button-success"
                icon="pi pi-check" :disabled="loading">
              </Button>
              <router-link to="/categoriaTarifaListagem">
                <Button label="Voltar" title="Voltar" type="button" class="p-button-primary mr-2"
                  icon="pi pi-arrow-left" :disabled="loading"></Button>
              </router-link>
            </template>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import money from "../conf/config.money";
import LoginService from "../services/acesso/login.service";
import CategoriaTarifa from "../models/nfse/CategoriaTarifa";
import CategoriaTarifaService from '../services/nfse/categoria.tarifa.service';

export default {
  name: "categoriaTarifaCadastro",
  data() {
    return {
      money: money,
      currentUser: null,
      loading: false,
      CategoriaTarifa: new CategoriaTarifa(),
      validationErrors: {},
      opcoes: [{ name: "Sim", key: "S" }, { name: "Não", key: "N" }],
    };
  },
  created() {
    this.currentUser = LoginService.currentUserValue;
    this.CatTarifaId = this.$route.params.id;

    if (this.CatTarifaId != null) {
      setTimeout(async () => {
        await CategoriaTarifaService.getCategoriaTarifa(this.CatTarifaId).then(
          response => {
            this.CategoriaTarifa = response.data;
          },
          error => {
            let errorMessage = "Houve um problema ao buscar a Categoria Tarifa!";
            if (error.response) {
              errorMessage = error.response.data;
            }
            this.$toast.add({
              severity: "error",
              summary: errorMessage
            });
          });
      }, 250);
    }
  },
  methods: {
    onSubmit() {
      this.loading = true;
      this.salvar();
      this.loading = false;
    },
    salvar() {
      this.CategoriaTarifa.idCliente = this.currentUser.usuario.idCliente;      
      CategoriaTarifaService.save(this.CategoriaTarifa).then(
        data => {
          console.log(data);
          this.$toast.add({
            severity: "success",
            summary: "Pedágio salvo com sucesso"
          });
          this.$router.push("categoriaTarifaListagem");
        },
        error => {
          let errorMessage = "Houve um problema ao salvar a Categoria!";
          if (error.response) {
            errorMessage = error.response.data;
          }
          this.$toast.add({
            severity: "error",
            summary: errorMessage
          });
        }
      );
    },
    editarTipo() {
      this.$root.$emit("emolumento:novoTipo", this.currentUser.usuario.idCliente);
    },
    processando(show) {
      if (show) {
        this.loading = true;
        this.$root.$emit("loading:show");
      } else {
        this.loading = false;
        this.$root.$emit("loading:hide");
      }
    }
  }
};
</script>

<style scoped>
textarea {
  width: 100%;
  border-radius: 3px;
}
</style>